module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/func_message-d6739377959cc09accf289a958344116.png";